import React from 'react';
import { CheckCircle, AlertCircle, X, Info } from 'lucide-react';

const Popup = ({ 
  isOpen, 
  onClose, 
  type = 'success', 
  title, 
  message, 
  showCloseButton = true,
  autoClose = false,
  autoCloseDelay = 3000
}) => {
  // Auto cerrar si está habilitado
  React.useEffect(() => {
    if (isOpen && autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="w-6 h-6 text-green-600" />;
      case 'error':
        return <AlertCircle className="w-6 h-6 text-red-600" />;
      case 'warning':
        return <AlertCircle className="w-6 h-6 text-yellow-600" />;
      case 'info':
        return <Info className="w-6 h-6 text-blue-600" />;
      default:
        return <CheckCircle className="w-6 h-6 text-green-600" />;
    }
  };

  const getBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-50 border-green-200';
      case 'error':
        return 'bg-red-50 border-red-200';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200';
      case 'info':
        return 'bg-blue-50 border-blue-200';
      default:
        return 'bg-green-50 border-green-200';
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'success':
        return 'text-green-800';
      case 'error':
        return 'text-red-800';
      case 'warning':
        return 'text-yellow-800';
      case 'info':
        return 'text-blue-800';
      default:
        return 'text-green-800';
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />
      
      {/* Popup */}
      <div className={`relative max-w-md w-full mx-4 p-6 rounded-lg border-2 shadow-xl ${getBgColor()}`}>
        {/* Header */}
        <div className="flex items-start space-x-3">
          {getIcon()}
          <div className="flex-1">
            {title && (
              <h3 className={`text-lg font-semibold ${getTextColor()}`}>
                {title}
              </h3>
            )}
            {message && (
              <p className={`mt-2 text-sm ${getTextColor()}`}>
                {message}
              </p>
            )}
          </div>
          
          {showCloseButton && (
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;

